
import routes from './routes'
import { Fetch } from '../fetch'

class MyPaments {
  async fetchPayments ({ body = {} }) {
    return Fetch(
      'get',
      routes.TriumphPayGetPayments(body),
      null,
      { apiVersion: 'v2' }
    )
  }

  async fetchInvoices ({ body = {} }) {
    return Fetch(
      'get',
      routes.TriumphPayGetInvoices(body),
      null,
      { apiVersion: 'v2' }
    )
  }

  async fetchPayoutTermsTypes () {
    return Fetch(
      'get',
      routes.TriumphPayoutTermsTypes,
      null,
      { apiVersion: 'v2' }
    )
  }

  async getTriumphPayUrl () {
    return Fetch(
      'get',
      routes.TriumphPayUrl,
      null,
      { apiVersion: 'v2' }
    )
  }

  async generateTriumphPayToken (code) {
    return Fetch(
      'get',
      routes.TriumphPayToken(code),
      null,
      { apiVersion: 'v2' }
    )
  }
}

export default new MyPaments()
